import axios from "axios"

const IP_URL = process.env.IP_URL

console.log(IP_URL)

// Obter configuração baseada no ambiente
// REACT_APP_API_URL permite apontar o painel pra uma API local em testes; sem ela, produção.
const apiConfig = process.env.REACT_APP_API_URL || 'https://28oztu5z88.execute-api.sa-east-1.amazonaws.com/production';

const api = axios.create({
    baseURL: apiConfig
})

// Interceptor para adicionar token automaticamente
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("@Auth:token");
        if (token) {
            config.headers.Authorization = `Bearer ${JSON.parse(token)}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor para tratamento de erros
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.clear();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api